import React from 'react';
import PropTypes from 'prop-types';
import { strings, getCurrentLocale } from './../../../localization';
import EventMedia from '../../pages/dashboard/EventMedia/EventMedia';
import { getAwsS3SignedUrl } from '../../../data/media/api';
import RavenUtil from '../ravenUtil';
import { EVENT_MEDIA_STATUS, RC_API_EVENT_MEDIA_STATUS, EVENT_MEDIA_REQUEST_TYPE, EVENT_MEDIA_CAMERA_TYPE } from '../../pages/dashboard/EventMedia/eventMediaConstants';

import { connect } from 'react-redux';
import ProgressOverlay from './../../../components/common/ProgressOverlay';
import { EVENT_FLAG_IDS } from '../../../data/review/duck';
import MapboxStaticImage from '../../mapbox/mapboxStaticImage/mapboxStaticImage';
import { SpeedZoneBadge } from '../speedZones/SpeedZoneBadge';
import moment from 'moment';
import SettingsSelectors from '../../../data/settings/selectors';
import FlagDropDown from './FlagDropDown';
import Protected from '../protected';
import Permissions from '../../../data/permissions';
import LocationIQStaticImage, { getLocationIQEventMarkerColor } from '../../locationIQ/locationIQStaticImage';

export const EVENT_SUMMARY_ITEM_UNIQUE_ID_PREFIX = "event-summary-item-unique-id-prefix-";
const DEFAULT_UOM = 'IMPERIAL';
const UPDATE_FLAG_TIMEOUT = 15000;

const maxNoteCharacters = 300;

class EventSummaryItem extends React.PureComponent {

    static propTypes = {

        features: PropTypes.object.isRequired,
        reportItem: PropTypes.object.isRequired,
        eventItem: PropTypes.object,
        card: PropTypes.object,
        stage: PropTypes.string,

        eventId: PropTypes.string.isRequired,
        eventIdWithUnixTimestamp: PropTypes.string.isRequired,

        ravenUuid: PropTypes.string.isRequired,
        ts: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,

        eventFlags: PropTypes.object.isRequired, // for multiple flags
        eventNote: PropTypes.string,

        eventFlagPending: PropTypes.bool.isRequired,
        eventFlagChecked: PropTypes.bool,
        eventFlagErrorMessages: PropTypes.string,
        applyEventFlag: PropTypes.func.isRequired,
        timeoutEventFlag: PropTypes.func.isRequired,

        eventNotePending: PropTypes.bool.isRequired,
        eventNoteSaved: PropTypes.bool,
        eventNoteErrorMessages: PropTypes.string,
        applyEventNote: PropTypes.func.isRequired,
        timeoutEventNote: PropTypes.func.isRequired,

        unitOfMeasure: PropTypes.oneOf(['METRIC', 'IMPERIAL']).isRequired,

        eventMediaStatusForRoadCamera: PropTypes.string,
        eventMediaStatusForCabinCamera: PropTypes.string,

        previewVideoUrlRoad: PropTypes.string,
        previewVideoUrlCabin: PropTypes.string,

        requestEventMedia: PropTypes.func,

        ravenIsOffline: PropTypes.bool,

        profileImageComponent: PropTypes.node,

        facialRecognitionEnabled: PropTypes.bool,

        historyUrlOverride: PropTypes.string,
        TODOSHOWCASETHINGOVERRIDE: PropTypes.string,

        isWaitingForCardEventSummaries: PropTypes.bool,
    }

    constructor(props) {
        super(props);

        this.mounted = true;

        this.state = {

            selectedCameraType: EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD,

            previewImageUrlRoad: undefined,
            previewVideoUrlRoad: undefined,
            previewVideoMediaIdRoad: undefined,

            previewImageUrlCabin: undefined,
            previewVideoUrlCabin: undefined,
            previewVideoMediaIdCabin: undefined,

            streamingArchiveUrl: undefined,
            streamingArchiveMediaId: undefined,

            eventMediaStatusRoad: EVENT_MEDIA_STATUS.CREATE_SIGNED_URL_IN_PROGRESS,
            eventMediaStatusCabin: EVENT_MEDIA_STATUS.CREATE_SIGNED_URL_IN_PROGRESS,

            eventNote: this.props.eventNote || "",
            eventFlags: this.props.eventFlags || {},

            isSummaryButtonClicked: false,
            isViewTripButtonClicked: false,

            isEditingNote: false,
        }
        this.applyEventFlagTimeoutId = undefined;
        this.applyEventNoteTimeoutId = undefined;
    }

    componentDidMount() {
        this.setState({
            eventNote: this.props.eventNote,
            eventFlags: this.props.eventFlags,
        });

        if ((this.props.eventItem)) {
            this.initializeMediaStatuses();
            this.getPreviewImageUrls();
            this.getPreviewVideoUrls();
        }

        this.adjustTextareaHeight();
    }

    componentDidUpdate(prevProps, prevState) {

        // Update the state when the props change
        if (prevProps.eventNote !== this.props.eventNote) {
            this.setState({ eventNote: this.props.eventNote });
        }

        if (prevProps.eventFlags !== this.props.eventFlags) {
            this.setState({ eventFlags: this.props.eventFlags }, () => {
            });
        }

        if (this.props.eventFlags !== this.state.eventFlags) {
            this.setState({ eventFlags: this.props.eventFlags }, () => {
            });
        }

        // onload fallback for componentDidMount trigger:
        if ((!prevProps.eventItem && this.props.eventItem)) {
            this.initializeMediaStatuses();
            this.getPreviewImageUrls();
            this.getPreviewVideoUrls();
        }

        // on reuse
        if (prevProps.eventId !== this.props.eventId) {
            this.setState({
                previewImageUrlRoad: undefined,
                previewVideoUrlRoad: undefined,
                previewVideoMediaIdRoad: undefined,

                previewImageUrlCabin: undefined,
                previewVideoUrlCabin: undefined,
                previewVideoMediaIdCabin: undefined,

                streamingArchiveUrl: undefined,
                streamingArchiveMediaId: undefined,

                eventMediaStatusRoad: EVENT_MEDIA_STATUS.CREATE_SIGNED_URL_IN_PROGRESS,
                eventMediaStatusCabin: EVENT_MEDIA_STATUS.CREATE_SIGNED_URL_IN_PROGRESS
            });
            if (this.props.eventItem) {
                this.initializeMediaStatuses();
                this.getPreviewImageUrls();
                this.getPreviewVideoUrls();
            }
        }

        this.adjustTextareaHeight();
    }

    componentWillUnmount() {
        this.mounted = false;
        this.setState({
            previewImageUrlRoad: undefined,
            previewVideoUrlRoad: undefined,
            previewVideoMediaIdRoad: undefined,

            previewImageUrlCabin: undefined,
            previewVideoUrlCabin: undefined,
            previewVideoMediaIdCabin: undefined,

            streamingArchiveUrl: undefined,
            streamingArchiveMediaId: undefined,

            eventMediaStatusRoad: EVENT_MEDIA_STATUS.CREATE_SIGNED_URL_IN_PROGRESS,
            eventMediaStatusCabin: EVENT_MEDIA_STATUS.CREATE_SIGNED_URL_IN_PROGRESS,

            isSummaryButtonClicked: false,
            isViewTripButtonClicked: false,
        });
        clearTimeout(this.applyEventFlagTimeoutId);
        clearTimeout(this.applyEventNoteTimeoutId);
    }

    handleSummaryClick = (e) => {
        this.setState({ isSummaryButtonClicked: true });
    }

    handleViewTripClick = (e) => {
        this.setState({ isViewTripButtonClicked: true });
    }

    handleFlagChange = (e, flagName) => {
        const checked = e.target.checked;
        const { ravenUuid, eventIdWithUnixTimestamp } = this.props;
        const newEventFlags = { ...this.state.eventFlags };

        clearTimeout(this.applyEventFlagTimeoutId);  // clear any existing timeout

        this.applyEventFlagTimeoutId = setTimeout(() => {
            this.props.timeoutEventFlag(checked, ravenUuid, eventIdWithUnixTimestamp, newEventFlags);
        }, UPDATE_FLAG_TIMEOUT);

        this.props.applyEventFlag(this.props.stage, checked, ravenUuid, eventIdWithUnixTimestamp, flagName, newEventFlags)
            .then(
                () => { clearTimeout(this.applyEventFlagTimeoutId); },
                () => { clearTimeout(this.applyEventFlagTimeoutId); }
            );
        newEventFlags[EVENT_FLAG_IDS[flagName]] = checked; // Update the new flags object with the new flag value
        // Update the state with the new event flags
        this.setState({ 
            eventFlags: newEventFlags,
        });
    };

    handleInputChange = (e) => {
        const inputText = e.target.value;
        if (inputText.length <= maxNoteCharacters) {
            this.setState({ eventNote: inputText });
        }
        this.adjustTextareaHeight();
    }

    adjustTextareaHeight() {
        if (this.textarea) {
            this.textarea.style.height = "auto"; // Reset height
            this.textarea.style.height = `${this.textarea.scrollHeight}px`; // Adjust to content
        }
    }

    handleDeleteClick = () => {

        const { ravenUuid, eventIdWithUnixTimestamp, eventNoteSaved } = this.props;
        this.setState({ eventNote: "" });

        clearTimeout(this.applyEventNoteTimeoutId);

        this.applyEventNoteTimeoutId = setTimeout(() => {
            this.props.timeoutEventNote(eventNoteSaved, ravenUuid, eventIdWithUnixTimestamp, "");
        }, UPDATE_FLAG_TIMEOUT);

        this.props.applyEventNote(this.props.stage, !eventNoteSaved, ravenUuid, eventIdWithUnixTimestamp, "")
            .then(
                () => { clearTimeout(this.applyEventNoteTimeoutId) },
                () => { clearTimeout(this.applyEventNoteTimeoutId) }
            );
    }

    handleSaveClick = () => {

        const { ravenUuid, eventIdWithUnixTimestamp, eventNoteSaved } = this.props;
        const { eventNote } = this.state;

        clearTimeout(this.applyEventNoteTimeoutId);

        this.applyEventNoteTimeoutId = setTimeout(() => {
            this.props.timeoutEventNote(eventNoteSaved, ravenUuid, eventIdWithUnixTimestamp, eventNote);
        }, UPDATE_FLAG_TIMEOUT);

        this.props.applyEventNote(this.props.stage, !eventNoteSaved, ravenUuid, eventIdWithUnixTimestamp, eventNote)
            .then(
                () => { clearTimeout(this.applyEventNoteTimeoutId) },
                () => { clearTimeout(this.applyEventNoteTimeoutId) }
            );
    }

    initializeMediaStatuses = () => {

        let eventMediaStatusRoad = this.state.eventMediaStatusRoad;
        let eventMediaStatusCabin = this.state.eventMediaStatusCabin;

        let previewMediaRoad;
        let previewMediaCabin;

        if (this.props.eventItem) {
            for (let i = 0; i < this.props.eventItem.mediaList.length; i += 1) {
                if (previewMediaRoad && previewMediaCabin) {
                    break;
                }

                const mediaItem = this.props.eventItem.mediaList[i];

                if (!mediaItem?.url){
                    continue;
                }

                if (["MEDIA_PREVIEW", "MEDIA_PREVIEW_VIDEO"].includes(mediaItem.type)) {
                    if (mediaItem.cameraType === EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD) {
                        previewMediaRoad = mediaItem;
                    } else {
                        previewMediaCabin = mediaItem;
                    }
                }
            }
        }

        let previewVideoMediaIdRoad = this.state.streamingArchiveUrl ? this.state.streamingArchiveMediaId : this.state.previewVideoMediaIdRoad;
        let previewVideoMediaIdCabin = this.state.streamingArchiveUrl ? undefined : this.state.previewVideoMediaIdCabin;

        if (this.props.eventItem) {
            if (!previewMediaRoad && !previewVideoMediaIdRoad) {
                eventMediaStatusRoad = EVENT_MEDIA_STATUS.NOT_FOUND_PREVIEW_IMAGE;
            }

            if (!previewMediaCabin && !previewVideoMediaIdCabin) {
                eventMediaStatusCabin = EVENT_MEDIA_STATUS.NOT_FOUND_PREVIEW_IMAGE;
            }
        }

        this.setState({
            eventMediaStatusRoad: eventMediaStatusRoad,
            eventMediaStatusCabin: eventMediaStatusCabin
        });
    }

    getPreviewImageUrls = () => {

        const eventMediaList = this.props.eventItem ? this.props.eventItem.mediaList : [];

        for (let i = 0; i < eventMediaList.length; i += 1) {

            if (eventMediaList[i].type === "MEDIA_PREVIEW") {

                if (!eventMediaList[i].url) continue;

                getAwsS3SignedUrl({ key: eventMediaList[i].url }).then((res) => {
                    if (!this.mounted) {
                        return;
                    }
                    if (eventMediaList[i].cameraType === EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD) {
                        this.setState({
                            previewImageUrlRoad: res.url,
                            previewVideoMediaIdRoad: eventMediaList[i].mediaId
                        });
                    } else {
                        this.setState({
                            previewImageUrlCabin: res.url,
                            previewVideoMediaIdCabin: eventMediaList[i].mediaId
                        });
                    }
                });
            }
        }
    }

    getPreviewVideoUrls = () => {

        const eventMediaList = this.props.eventItem ? this.props.eventItem.mediaList : [];

        if (!eventMediaList) {
            return;
        }

        for (let i = 0; i < eventMediaList.length; i += 1) {

            if (eventMediaList[i].type === "MEDIA_PREVIEW_VIDEO") {

                if (!eventMediaList[i].url) continue;

                getAwsS3SignedUrl({ key: eventMediaList[i].url }).then((res) => {
                    if (!this.mounted) {
                        return;
                    }

                    if (eventMediaList[i].cameraType === EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD) {
                        this.setState({ previewVideoUrlRoad: res.url });
                    } else {
                        this.setState({ previewVideoUrlCabin: res.url });
                    }
                });

                continue;
            }

            if (eventMediaList[i].type === "MEDIA_STREAMING_ARCHIVE") {

                if (!eventMediaList[i].url) continue;

                getAwsS3SignedUrl({ key: eventMediaList[i].url }).then((res) => {
                    if (!this.mounted) {
                        return;
                    }

                    this.setState({ streamingArchiveUrl: res.url });
                });
            }
        }
    }

    getEventMarkerColor = (eventType) => {
        switch (eventType) {
            case 'EVENT_ENGINE_ON':
            case 'EVENT_ENGINE_OFF':
                return '4A8E16'; // $green-dark
            case 'EVENT_SPEEDING_STARTED':
            case 'EVENT_SPEEDING_STOPPED':
            case 'EVENT_IDLING_STARTED': 
            case 'EVENT_IDLING_STOPPED':
            case 'EVENT_HARD_BRAKING':
            case 'EVENT_OBD_DTC_ALERT':
            case 'EVENT_OBD_DTC_CLEARED':
            case 'EVENT_ACCIDENT':
            case 'EVENT_POSSIBLE_IMPACT':
            case 'EVENT_RAVEN_BAD_INSTALL_DETECTED':
            case 'EVENT_RAVEN_BAD_INSTALL_CLEARED':
                return 'C22626'; // $red-dark
            case 'EVENT_RAVEN_GEOFENCE_ENTER':
            case 'EVENT_RAVEN_GEOFENCE_EXIT':
                return '6E6E6E'; // $grey-medium-dark
            default:
                return 'A48229'; // $yellow-dark
        }

    }

    requestEventUserVideo = (cameraType) => {
        const {stage, ravenUuid, eventId, eventItem} = this.props;
        const eventType = eventItem ? eventItem.type : undefined;
        const timestamp = RavenUtil.toDate(eventItem.ts).getTime() / 1000; // Convert to Unix timestamp
        this.props.requestEventMedia(stage, ravenUuid, eventId, cameraType, timestamp, 15, eventType);
    }

    requestEventUserVideoForCabin = () => {
        this.requestEventUserVideo('CABIN');
    }

    requestEventUserVideoForRoad = () => {
        this.requestEventUserVideo('ROAD');
    }

    convertRcAPIStatusToEventMediaStatus = (rcAPIStatus) => {
        switch (rcAPIStatus) {
            case RC_API_EVENT_MEDIA_STATUS.AVAILABLE:
                return EVENT_MEDIA_STATUS.PREVIEW_VIDEO_AVAILABLE;
            case RC_API_EVENT_MEDIA_STATUS.CREATE_PREVIEW_VIDEO_REQUEST_SENT:
                return EVENT_MEDIA_STATUS.CREATE_PREVIEW_VIDEO_REQUEST_SENT;
            case RC_API_EVENT_MEDIA_STATUS.ERROR:
                return EVENT_MEDIA_STATUS.ERROR;
            case RC_API_EVENT_MEDIA_STATUS.SOURCE_GONE:
                return EVENT_MEDIA_STATUS.SOURCE_GONE;
            case RC_API_EVENT_MEDIA_STATUS.SOURCE_AVAILABLE:
                return EVENT_MEDIA_STATUS.SOURCE_AVAILABLE;
            case RC_API_EVENT_MEDIA_STATUS.ERROR_REQUEST_TIMEOUT:
                return EVENT_MEDIA_STATUS.ERROR_REQUEST_TIMEOUT;
            case RC_API_EVENT_MEDIA_STATUS.PENDING:
                return EVENT_MEDIA_STATUS.CREATE_PREVIEW_VIDEO_REQUEST_SENT;
            case RC_API_EVENT_MEDIA_STATUS.PENDING_UPLOAD:
                return EVENT_MEDIA_STATUS.MEDIA_INITIATED;
            case RC_API_EVENT_MEDIA_STATUS.PREPARING_ON_DEVICE:
                return EVENT_MEDIA_STATUS.MEDIA_INITIATED;
            case RC_API_EVENT_MEDIA_STATUS.UPLOAD_FAILED:
                return EVENT_MEDIA_STATUS.ERROR_UPLOAD_FAILED;
            case RC_API_EVENT_MEDIA_STATUS.UPLOADING:
                return EVENT_MEDIA_STATUS.MEDIA_UPLOAD_INITIATED;
            case undefined:
                return undefined;
            default:
                console.error("Unknown event media status from API", rcAPIStatus);
                return EVENT_MEDIA_STATUS.ERROR;
        }
    }

    isThereAPlaybackError = (cameraType) => {
        
        if (cameraType === EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD && this.state.eventMediaStatusRoad === EVENT_MEDIA_STATUS.ERROR_PLAYBACK_FAILED) {
            return true;
        }

        if (cameraType === EVENT_MEDIA_CAMERA_TYPE.CAMERA_CABIN && this.state.eventMediaStatusCabin === EVENT_MEDIA_STATUS.ERROR_PLAYBACK_FAILED) {
            return true;
        }

        return false;
    }
    
    getMergedEventMediaStatus = (cameraType) => {
        
        // If a playback error occurred, it takes priority over everything else
        if(this.isThereAPlaybackError(cameraType)) {
            return EVENT_MEDIA_STATUS.ERROR_PLAYBACK_FAILED;
        }

        // These indicate 2 things
        // 1- If a request for video is made, what is the request's status
        // 2- If a request is not made, what is the event.availableVideo status. Is there a video to be requested or not (it's part of card's data)
        const requestVideoStatusRoad = this.convertRcAPIStatusToEventMediaStatus(this.props.eventMediaStatusForRoadCamera);
        const requestVideoStatusCabin = this.convertRcAPIStatusToEventMediaStatus(this.props.eventMediaStatusForCabinCamera);

        // These are set in the initializeMediaStatuses method
        // They can be one of the 2 values
        // 1- default: EVENT_MEDIA_STATUS.CREATE_SIGNED_URL_IN_PROGRESS
        // 2- if no preview media: EVENT_MEDIA_STATUS.NOT_FOUND_PREVIEW_IMAGE 
        const previewStatusRoad = this.state.eventMediaStatusRoad;
        const previewStatusCabin = this.state.eventMediaStatusCabin;

        const roadHasPreviewVideo = !!this.state.previewVideoUrlRoad;
        const roadHasPreviewImage = !!this.state.previewImageUrlRoad;

        const cabinHasPreviewVideo = !!this.state.previewVideoUrlCabin;
        const cabinHasPreviewImage = !!this.state.previewImageUrlCabin;


        let mergedStatusRoad = requestVideoStatusRoad || previewStatusRoad;
        let mergedStatusCabin = requestVideoStatusCabin || previewStatusCabin;


        // Different cases can be:
        // 1 - There is a preview media (image or video): returns RequestVideoStatus as it is
        // 2 - No preview media (image or video):
        //   2-1 - If RequestVideoStatus is SOURCE_AVAILABLE => returns SOURCE_AVAILABLE_WITHOUT_PREVIEW_IMAGE (EventMedia would show the 'no preview' overlay AND a request button)
        //   2-2 - If RequestVideoStatus is SOURCE_GONE or undefined => returns NOT_FOUND_PREVIEW_IMAGE (EventMedia would show the 'no preview' overlay BUT no request button)
        //   2-3 - If a video request is in progress (CREATE_PREVIEW_VIDEO_REQUEST_SENT, MEDIA_INITIATED, etc) => returns the RequestVideoStatus (EventMedia would show a proper overlay indicating the request status)

        // Road logic
        if (!roadHasPreviewVideo) {
            if (!roadHasPreviewImage) {
                if (previewStatusRoad === EVENT_MEDIA_STATUS.NOT_FOUND_PREVIEW_IMAGE) {
                    switch (requestVideoStatusRoad) {
                        case EVENT_MEDIA_STATUS.SOURCE_AVAILABLE:
                            mergedStatusRoad = EVENT_MEDIA_STATUS.SOURCE_AVAILABLE_WITHOUT_PREVIEW_IMAGE;
                            break;
                        case EVENT_MEDIA_STATUS.SOURCE_GONE:
                        case undefined:
                            mergedStatusRoad = EVENT_MEDIA_STATUS.NOT_FOUND_PREVIEW_IMAGE;
                            break;
                        // The status of a request in progress
                        default:
                            mergedStatusRoad = requestVideoStatusRoad;
                    }
                }
            }
        }

        // Cabin logic (same semantics)
        if (!cabinHasPreviewVideo) {
            if (!cabinHasPreviewImage) {
                if (previewStatusCabin === EVENT_MEDIA_STATUS.NOT_FOUND_PREVIEW_IMAGE) {
                    switch (requestVideoStatusCabin) {
                        case EVENT_MEDIA_STATUS.SOURCE_AVAILABLE:
                            mergedStatusCabin = EVENT_MEDIA_STATUS.SOURCE_AVAILABLE_WITHOUT_PREVIEW_IMAGE;
                            break;
                        case EVENT_MEDIA_STATUS.SOURCE_GONE:
                        case undefined:
                            mergedStatusCabin = EVENT_MEDIA_STATUS.NOT_FOUND_PREVIEW_IMAGE;
                            break;
                        // The status of a request in progress
                        default:
                            mergedStatusCabin = requestVideoStatusCabin;
                    }
                }
            }
        }

        return cameraType === EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD ? mergedStatusRoad : mergedStatusCabin;
    };

    render() {
        let eventDate;
        let eventName;
        let vehicleName;
        let driverName;
        let eventElementUniqueId;

        let unitOfMeasure = DEFAULT_UOM;
        if (this.props.unitOfMeasure) {
            unitOfMeasure = this.props.unitOfMeasure.toUpperCase();
        }

        const summaryButtonClass = this.state.isSummaryButtonClicked ? "btn btn-sm btn-outline-blue" : "btn btn-sm btn-outline-black";
        const viewTripButtonClass = this.state.isViewTripButtonClicked ? "btn btn-sm btn-outline-blue" : "btn btn-sm btn-outline-black";

        if (this.props.reportItem) {
            eventDate = RavenUtil.toDate(this.props.reportItem["FactEvent.timestamp"]);
            eventName = document.getEventName({ type: this.props.reportItem["DimEventType.name"] });
            vehicleName = this.props.reportItem["DimVehicle.name"];
            driverName = this.props.reportItem["DimDriver.name"];
            eventElementUniqueId = EVENT_SUMMARY_ITEM_UNIQUE_ID_PREFIX + this.props.eventId;
        }

        let tripHistoryHref = "/" + getCurrentLocale() + "/stats/history/";
        if (this.props.historyUrlOverride) {
            tripHistoryHref = this.props.historyUrlOverride; // showcase
        } else if (this.props.reportItem) {
            tripHistoryHref += this.props.reportItem["DimRaven.uuid"] + "/" + this.props.reportItem["DimCard.cardId"];
        }

        let eventReportHref = "/" + getCurrentLocale() + "/stats/history/";
        if (this.props.TODOSHOWCASETHINGOVERRIDE) {
            eventReportHref = this.props.TODOSHOWCASETHINGOVERRIDE; // showcase
        } else if (this.props.reportItem) {
            eventReportHref += this.props.reportItem["DimRaven.uuid"] + "/" + this.props.reportItem["DimCard.cardId"] + "/" + this.props.eventId;
            const hasEventNote = this.props.eventNote && this.props.eventNote.length > 0;
            const hasEventFlags = this.props.eventFlags && Object.values(this.props.eventFlags).some(flag => flag);

            if (hasEventNote || hasEventFlags) {
                eventReportHref += "?";
                if (hasEventNote) {
                    eventReportHref += "note=" + encodeURIComponent(this.props.eventNote);
                }
                if (hasEventFlags) {
                    if (hasEventNote) {
                        eventReportHref += "&";
                    }
                    eventReportHref += "flags=" + Object.keys(this.props.eventFlags).filter(flag => this.props.eventFlags[flag]).join(",");
                }
            }
        }

        const eventType = this.props.eventItem ? this.props.eventItem.type : undefined
        let showAlternateCameraEventMedia = true;
        let eventBadgeComponent;
        switch (eventType) {
            case "EVENT_KLOUD_LIVE_STREAMING":
            case "EVENT_KLOUD_HISTORICAL_STREAMING":
                showAlternateCameraEventMedia = false;
                break;

            case "EVENT_SPEEDING_STARTED":
                if(!this.props.card) break; // no speed zone data without card
                const speedZone = RavenUtil.getSpeedzoneForEvent(this.props.card, this.props.eventItem);
                if (speedZone) {
                    const speedLimit = speedZone.speedLimit;
                    const maxSpeed = speedZone.maxSpeed;
                    const startTime = speedZone.startTime;
                    const startDate = new Date(startTime);
                    const endTime = speedZone.endTime;
                    const endDate = new Date(endTime);

                    if (!speedLimit) {
                        console.error("eventScrollableList createEventList speeding event, speedZone invalid speedLimit", speedZone);
                    } else if (!maxSpeed) {
                        console.error("eventScrollableList createEventList speeding event, speedZone invalid maxSpeed", speedZone);
                    } else if (!startTime) {
                        console.error("eventScrollableList createEventList speeding event, speedZone invalid startTime", speedZone);
                    } else if (!endTime) {
                        console.error("eventScrollableList createEventList speeding event, speedZone invalid endTime", speedZone);
                    } else {
                        eventBadgeComponent = (
                            <SpeedZoneBadge
                                speedLimit={speedLimit}
                                maxSpeed={maxSpeed}
                                startDate={startDate}
                                endDate={endDate}
                                unitOfMeasure={unitOfMeasure}
                            />
                        );
                    }
                }
                break;
            default:
                break;
        }

        const lat = this.props.eventItem && this.props.eventItem.geoStamp && this.props.eventItem.geoStamp.lat ? this.props.eventItem.geoStamp.lat : 0;
        const lon = this.props.eventItem && this.props.eventItem.geoStamp && this.props.eventItem.geoStamp.lon ? this.props.eventItem.geoStamp.lon : 0;

        const hasGPSData = (lat !== 0 && lon !== 0);

        const markerColor = this.getEventMarkerColor(this.props.type);
        const locationIQMarkerColor = getLocationIQEventMarkerColor(this.props.type);

        const options = Object.keys(EVENT_FLAG_IDS).map((flagName) => ({
            value: flagName,
            label: strings[flagName.toLowerCase() + '_label'],
            checked: this.state.eventFlags[EVENT_FLAG_IDS[flagName]] || false,
        }));

        const anyFlagIsChecked = options.some(flag => flag.checked);
        const noteFieldPlaceholder = anyFlagIsChecked ? strings.event_note_label : strings.event_note_label_first_select_flags;

        const noStatusApplied = !Object.values(this.state.eventFlags).some(flag => flag);
        const highlightRedEventType = (this.props.type === "EVENT_HARD_BRAKING" || this.props.type === "EVENT_SPEEDING_STARTED" || this.props.type === "EVENT_POSSIBLE_IMPACT");
        
        let mediaRequestType = EVENT_MEDIA_REQUEST_TYPE.NONE;
        if(this.props.features?.media_request && this.props.canRequestMedia) {
            mediaRequestType = EVENT_MEDIA_REQUEST_TYPE.USER_MEDIA_REQUEST;
        }

        const eventMediaStatusToPassForRoad = this.getMergedEventMediaStatus(EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD);
        const eventMediaStatusToPassForCabin = this.getMergedEventMediaStatus(EVENT_MEDIA_CAMERA_TYPE.CAMERA_CABIN);
        
        return (
            <div className={"event-summary-item fr"} id={eventElementUniqueId}>
                <div className="info">
                    <span className="summary-item-label label-bold">{vehicleName}</span>
                    <span className={`summary-item-label label-bold + ${highlightRedEventType ? "event-highlight" : ""}`}><strong>{eventName}</strong></span>
                    <span className="summary-item-label">{(eventDate ? moment(eventDate).format("LL - LT") : null)}</span>
                </div>
                <div className="details">
                    <div className="display-details">
                        <div className="details-field">
                            <div className="summary-wrapper">
                                <div className="actions">
                                    <a href={eventReportHref} target="_blank" rel="noopener noreferrer" className={summaryButtonClass} onClick={this.handleSummaryClick}>
                                        {strings.action_summary}
                                    </a>
                                    <a href={tripHistoryHref} target="_blank" rel="noopener noreferrer" className={viewTripButtonClass} onClick={this.handleViewTripClick}>
                                        {strings.action_view_trip}
                                    </a>
                                </div>
                                <div className="feature">{eventBadgeComponent}</div>
                            </div>
                            <div className="driver-wrapper">                                
                                {this.props.profileImageComponent}
                                {this.props.features && this.props.features.facial_recognition && this.props.facialRecognitionEnabled ?
                                    <span className="driver-label">{driverName ? driverName : strings.unknown}</span>
                                    :
                                    <span></span>
                                }
                            </div>
                            <Protected resource="coaching" action="write">
                                <div className="flag-wrapper">
                                    <FlagDropDown options={options} onChange={this.handleFlagChange} isPending={this.props.eventFlagPending}/>
                                    <div className="flag-display">
                                        {noStatusApplied ? strings.event_flag_no_status_applied_label : (
                                            <span>
                                                <span className="bold-label">{strings.event_flag_status_label}</span>
                                                {options.filter(flag => flag.checked).map(flag => flag.label).join(', ')}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </Protected>
                        </div>
                        <Protected resource="coaching" action="write">
                            <div className="note-field">
                                <textarea disabled={!anyFlagIsChecked} className="note-area" ref={(textarea) => (this.textarea = textarea)} placeholder={noteFieldPlaceholder} value={this.state.eventNote} onChange={this.handleInputChange} onFocus={() => this.setState({ isEditingNote: true })} maxLength={maxNoteCharacters} />
                                <div className="note-details">
                                    <span className="note-limit">{this.state.eventNote.length}/{maxNoteCharacters}</span>
                                    {(this.state.isEditingNote == true && this.state.eventNote.length == maxNoteCharacters) ? <span className="note-limit-error">{strings.formatString(strings.event_note_max_characters_error, maxNoteCharacters)}</span> : null}
                                </div>
                                <div className='note-actions'>
                                    <button disabled={!anyFlagIsChecked} className="btn btn-sm btn-outline-black save-note" onClick={this.handleSaveClick}>{strings.action_save_note}</button>
                                    <button disabled={!anyFlagIsChecked} className='delete-note' onClick={this.handleDeleteClick}><i className="material-icons">delete_forever</i></button>
                                </div>
                            </div>
                        </Protected>
                    </div>
                    {this.props.eventNotePending || this.props.eventFlagPending ? <ProgressOverlay /> : null}
                </div>
                <div className="multi-panel-wrapper">
                    <EventMedia
                        shouldShowAlternateCameraType={false}
                        // from EventSummaryItem state:
                        previewImageUrl={this.state.previewImageUrlRoad}
                        previewVideoUrl={this.state.streamingArchiveUrl ? this.state.streamingArchiveUrl : this.state.previewVideoUrlRoad ? this.state.previewVideoUrlRoad : this.props.previewVideoUrlRoad}
                        status={eventMediaStatusToPassForRoad}
                        // static or derived from props:
                        eventId={this.props.eventId}
                        eventType={this.props.eventItem ? this.props.eventItem.type : undefined}
                        date={this.props.eventItem ? RavenUtil.toDate(this.props.eventItem.ts) : undefined}
                        cameraType={EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD}
                        previewVideoCameraType={EVENT_MEDIA_CAMERA_TYPE.CAMERA_ROAD}
                        createEventUserVideo={this.requestEventUserVideoForRoad}
                        mediaRequestType={mediaRequestType}
                        toggleCamera={undefined}
                        onVideoError={(mediaId, error) => {
                            console.error("EventSummaryItem road video error", error);
                            this.setState({
                                eventMediaStatusRoad: EVENT_MEDIA_STATUS.ERROR_PLAYBACK_FAILED,
                            });
                        }}
                        clearPlaybackError={() => {
                            this.setState({
                                eventMediaStatusRoad: EVENT_MEDIA_STATUS.PREVIEW_VIDEO_AVAILABLE,
                            });
                        }}
                        autoPlay={true}
                        offline={this.props.ravenIsOffline}
                    />
                    {showAlternateCameraEventMedia ?
                        <EventMedia
                            shouldShowAlternateCameraType={false}

                            // from EventSummaryItem state:
                            previewImageUrl={this.state.previewImageUrlCabin}
                            previewVideoUrl={this.state.streamingArchiveUrl ? undefined : this.state.previewVideoUrlCabin ? this.state.previewVideoUrlCabin : this.props.previewVideoUrlCabin}
                            status={eventMediaStatusToPassForCabin}

                            // static or derived from props:
                            eventId={this.props.eventId}
                            eventType={this.props.eventItem ? this.props.eventItem.type : undefined}
                            date={this.props.eventItem ? RavenUtil.toDate(this.props.eventItem.ts) : undefined}

                            cameraType={EVENT_MEDIA_CAMERA_TYPE.CAMERA_CABIN}
                            previewVideoCameraType={EVENT_MEDIA_CAMERA_TYPE.CAMERA_CABIN}
                            mediaRequestType={mediaRequestType}
                            createEventUserVideo={this.requestEventUserVideoForCabin}
                            toggleCamera={undefined}
                            onVideoError={(mediaId, error) => {
                                console.error("EventSummaryItem cabin video error", error);
                                this.setState({
                                    eventMediaStatusCabin: EVENT_MEDIA_STATUS.ERROR_PLAYBACK_FAILED,
                                });
                            }}
                            clearPlaybackError={() => {
                                this.setState({
                                    eventMediaStatusCabin: EVENT_MEDIA_STATUS.PREVIEW_VIDEO_AVAILABLE,
                                });
                            }}
                            autoPlay={true}
                            offline={this.props.ravenIsOffline}
                        />
                        :
                        <div className="event-media-spacer"></div>
                    }
                    <LocationIQStaticImage
                        width={1000}
                        height={600}
                        marker={{ latitude: lat, longitude: lon, color: locationIQMarkerColor }}
                        points={this.props.card ? this.props.card.route : undefined}
                        hasGPSData={hasGPSData}
                        defaultTheme={this.props.features.theme_selection ? this.props.features.theme_selection : 'light'}
                        isWaitingForGPSData={this.props.isWaitingForCardEventSummaries || !this.props.card} // To generate the static map, we need to wait for the GSP data & card.routes to be available
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        unitOfMeasure: SettingsSelectors.unitOfMeasure(state),
        canRequestMedia: Permissions.selectors.can(state, 'ravens.media', 'request', { resourceId: ownProps.ravenUuid }),
    };
}

export { EventSummaryItem as UnconnectedEventSummaryItem };
export default connect(mapStateToProps)(EventSummaryItem);